(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _mobileMenu = _interopRequireDefault(require("./modules/mobile-menu.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// Import mobileMenu class

// Initiate mobileMenu class
var menu = new _mobileMenu["default"]();

// code to detect scroll event and hide header logo with SCSS styling
window.addEventListener('scroll', function () {
  var header = document.getElementById('main-header');
  if (window.scrollY > 100) {
    header.classList.add('scrolled');
    console.log('screen scrolled! vanishing the logo!');
  } else {
    header.classList.remove('scrolled');
    console.log('removing special scrolled styling!');
  }
});

},{"./modules/mobile-menu.js":2}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* define mobile menu Open and Close functions */
var mobileMenu = /*#__PURE__*/function () {
  function mobileMenu() {
    _classCallCheck(this, mobileMenu);
    this.openMenu = document.getElementById("mobileNavOpen");
    this.closeMenu = document.getElementById("mobileNavClose");
    this.overlay = document.getElementById("myNav");
    console.log('loaded javascript for mobile menu');
    this.events();
  }
  return _createClass(mobileMenu, [{
    key: "events",
    value: function events() {
      this.openMenu.addEventListener('click', this.openMobileMenu.bind(this));
      this.closeMenu.addEventListener('click', this.closeMobileMenu.bind(this));
    }
  }, {
    key: "openMobileMenu",
    value: function openMobileMenu() {
      this.overlay.style.height = "260px";
      this.overlay.style.display = "flex";
      console.log('mobile menu opened');
    }
  }, {
    key: "closeMobileMenu",
    value: function closeMobileMenu() {
      this.overlay.style.height = "0%";
      this.overlay.style.display = "none";
      console.log('mobile menu closed');
    }
  }]);
}();
var _default = exports["default"] = mobileMenu;

},{}]},{},[1]);
